<template>
  <div class="container center-box">
  <form @submit.prevent="reset">
    <h3>忘記密碼</h3><br>
    <p>帳號: <input type="text" class="form-control" id="exampleInputEmail1"  v-model="data_send.email" placeholder="請輸入email帳號" ></p>
    <div class="row">
    <div class="col-sm">

     <button name="btn" type="submit" value="寄送密碼" class="btn btn-dark btn-lg text-light text-right ">寄送密碼</button>

    </div>
    <div class="col-sm">
   </div>
  </div>


</form>
</div>

</template>


<script>
import axios from 'axios'
export default{
  data(){
    return {
      email: '',
      // url:"https://aew.cyberhood.net/_rpc/v3/rpc_json.php",
      url:"_rpc/v3/rpc_json.php",
      data_send:{
        __rpcname: "AEW/Client/GrantForgotPassword",
        __ds: "center",
        __dbid: 0,
        email: ""
      }
    }
  },
  methods:{
    reset(){
      axios.post(this.url, JSON.stringify(this.data_send))
      .then((response) => console.log(response))
    }

  }
}


function sendPassword(){
    var f=document.forms[0];
    if(f.email.value==''){
        alert("請先輸入帳號！");
        return;
    }
    $(f.btn).prop('disabled',true);
    $.ajax({
        url: "/_rpc/v3/rpc_json.php",
        data: {
            __rpcname: "AEW/Client/GrantForgotPassword",
            __ds: "center",
            __dbid: 0,
            email: f.email.value
        },
        type: 'POST',
        success: function (e) {
            if(e.errcode>0){
                alert("錯誤！\n"+e.errmsg);
                $(f.btn).prop('disabled',false);
            }else{
                alert('密碼已寄出！');
            }
        },
        error: function (xhr, textStatus) {
            console.log('AJAX Failed!');
        },
    });
}
</script>



// WEBPACK FOOTER //
// src/views/Reset.vue